import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumEireDutyRateBand implements BaseEnumType {
  private static allValues: EnumEireDutyRateBand[] = []; // make sure this is top-most
  
  public static notDutiable = new EnumEireDutyRateBand(0, "NotDutiable", "enum_eire_duty_rate_band_not_dutiable");
  public static spiritsFrom1_21 = new EnumEireDutyRateBand(1, "SpiritsFrom1_21", "enum_eire_duty_rate_band_spirits_from1_21");
  public static beerFrom0_51To1_20 = new EnumEireDutyRateBand(2, "BeerFrom0_51To1_20", "enum_eire_duty_rate_band_beer_from0_51_to1_20");
  public static beerFrom1_21To2_80 = new EnumEireDutyRateBand(3, "BeerFrom1_21To2_80", "enum_eire_duty_rate_band_beer_from1_21_to2_80");
  public static beerFrom2_81 = new EnumEireDutyRateBand(4, "BeerFrom2_81", "enum_eire_duty_rate_band_beer_from2_81");
  public static wineTo5_50 = new EnumEireDutyRateBand(5, "WineTo5_50", "enum_eire_duty_rate_band_wine_to5_50");
  public static stillWineFrom5_51To15_00 = new EnumEireDutyRateBand(6, "StillWineFrom5_51To15_00", "enum_eire_duty_rate_band_still_wine_from5_51_to15_00");
  public static stillWineFrom15_01 = new EnumEireDutyRateBand(7, "StillWineFrom15_01", "enum_eire_duty_rate_band_still_wine_from15_01");
  public static sparklingWineFrom5_51 = new EnumEireDutyRateBand(8, "SparklingWineFrom5_51", "enum_eire_duty_rate_band_sparkling_wine_from5_51");
  public static ciderPerryTo2_80 = new EnumEireDutyRateBand(9, "CiderPerryTo2_80", "enum_eire_duty_rate_band_cider_perry_to2_80");
  public static ciderPerryFrom2_81To6_00 = new EnumEireDutyRateBand(10, "CiderPerryFrom2_81To6_00", "enum_eire_duty_rate_band_cider_perry_from2_81_to6_00");
  public static ciderPerryFrom6_01To8_50 = new EnumEireDutyRateBand(11, "CiderPerryFrom6_01To8_50", "enum_eire_duty_rate_band_cider_perry_from6_01_to8_50");
  public static stillCiderPerryFrom8_51 = new EnumEireDutyRateBand(12, "StillCiderPerryFrom8_51", "enum_eire_duty_rate_band_still_cider_perry_from8_51");
  public static sparklingCiderPerryFrom8_51 = new EnumEireDutyRateBand(13, "SparklingCiderPerryFrom8_51", "enum_eire_duty_rate_band_sparkling_cider_perry_from8_51");
  public static otherFermentedTo5_50 = new EnumEireDutyRateBand(14, "OtherFermentedTo5_50", "enum_eire_duty_rate_band_other_fermented_to5_50");
  public static stillOtherFermentedFrom5_51 = new EnumEireDutyRateBand(15, "StillOtherFermentedFrom5_51", "enum_eire_duty_rate_band_still_other_fermented_from5_51");
  public static sparklingOtherFermentedFrom5_51 = new EnumEireDutyRateBand(16, "SparklingOtherFermentedFrom5_51", "enum_eire_duty_rate_band_sparkling_other_fermented_from5_51");
  public static stillIntermediateTo15_00 = new EnumEireDutyRateBand(17, "StillIntermediateTo15_00", "enum_eire_duty_rate_band_still_intermediate_to15_00");
  public static stillIntermediateFrom15_01 = new EnumEireDutyRateBand(18, "StillIntermediateFrom15_01", "enum_eire_duty_rate_band_still_intermediate_from15_01");
  public static sparklingIntermediate = new EnumEireDutyRateBand(19, "SparklingIntermediate", "enum_eire_duty_rate_band_sparkling_intermediate");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumEireDutyRateBand.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNotDutiable() { return this === EnumEireDutyRateBand.notDutiable; }
  public isSpiritsFrom1_21() { return this === EnumEireDutyRateBand.spiritsFrom1_21; }
  public isBeerFrom0_51To1_20() { return this === EnumEireDutyRateBand.beerFrom0_51To1_20; }
  public isBeerFrom1_21To2_80() { return this === EnumEireDutyRateBand.beerFrom1_21To2_80; }
  public isBeerFrom2_81() { return this === EnumEireDutyRateBand.beerFrom2_81; }
  public isWineTo5_50() { return this === EnumEireDutyRateBand.wineTo5_50; }
  public isStillWineFrom5_51To15_00() { return this === EnumEireDutyRateBand.stillWineFrom5_51To15_00; }
  public isStillWineFrom15_01() { return this === EnumEireDutyRateBand.stillWineFrom15_01; }
  public isSparklingWineFrom5_51() { return this === EnumEireDutyRateBand.sparklingWineFrom5_51; }
  public isCiderPerryTo2_80() { return this === EnumEireDutyRateBand.ciderPerryTo2_80; }
  public isCiderPerryFrom2_81To6_00() { return this === EnumEireDutyRateBand.ciderPerryFrom2_81To6_00; }
  public isCiderPerryFrom6_01To8_50() { return this === EnumEireDutyRateBand.ciderPerryFrom6_01To8_50; }
  public isStillCiderPerryFrom8_51() { return this === EnumEireDutyRateBand.stillCiderPerryFrom8_51; }
  public isSparklingCiderPerryFrom8_51() { return this === EnumEireDutyRateBand.sparklingCiderPerryFrom8_51; }
  public isOtherFermentedTo5_50() { return this === EnumEireDutyRateBand.otherFermentedTo5_50; }
  public isStillOtherFermentedFrom5_51() { return this === EnumEireDutyRateBand.stillOtherFermentedFrom5_51; }
  public isSparklingOtherFermentedFrom5_51() { return this === EnumEireDutyRateBand.sparklingOtherFermentedFrom5_51; }
  public isStillIntermediateTo15_00() { return this === EnumEireDutyRateBand.stillIntermediateTo15_00; }
  public isStillIntermediateFrom15_01() { return this === EnumEireDutyRateBand.stillIntermediateFrom15_01; }
  public isSparklingIntermediate() { return this === EnumEireDutyRateBand.sparklingIntermediate; }

  public static getValues(): readonly EnumEireDutyRateBand[] {
    return EnumEireDutyRateBand.allValues;
  }

  public static getValuesExcept0(): readonly EnumEireDutyRateBand[] {
    return EnumEireDutyRateBand.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumEireDutyRateBand {
    const found = EnumEireDutyRateBand.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumEireDutyRateBand - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumEireDutyRateBand): EnumEireDutyRateBand {
    const found = name ? EnumEireDutyRateBand.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumEireDutyRateBand - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumEireDutyRateBand>): boolean {
    return this.key === other?.key;
  }
}